module.exports = __webpack_public_path__ + "static/media/quinn.efc3d352.jpeg";